import React from "react";
import { Check, FileCheck2, ShieldCheck, Smartphone } from "lucide-react";
import { Card } from "@/components/ui/card";
import { Badge } from "@/components/ui/badge";

const ICONS = { FileCheck2, ShieldCheck, Smartphone };

const ACCENT = {
  teal: { bar: "accent-bar-teal", chip: "bg-[#eef7f7] text-[#0f6e73]", tick: "text-[#0f6e73]" },
  navy: { bar: "accent-bar-navy", chip: "bg-[#eef2f8] text-[#123055]", tick: "text-[#123055]" },
  orange: { bar: "accent-bar-orange", chip: "bg-[#fef3e8] text-[#b4611b]", tick: "text-[#b4611b]" },
};

export const ServiceCard = ({ service }) => {
  const Icon = ICONS[service.icon] || FileCheck2;
  const accent = ACCENT[service.accent] || ACCENT.teal;

  return (
    <Card
      data-testid={`services-${service.key}-card`}
      className={`flex h-full flex-col rounded-[16px] border-slate-200 bg-white p-4 shadow-[var(--shadow-sm)] transition-shadow hover:shadow-[var(--shadow-md)] sm:p-5 ${accent.bar}`}
    >
      <div className="flex items-center justify-between gap-3">
        <span className={`flex h-11 w-11 items-center justify-center rounded-xl ${accent.chip}`}>
          <Icon className="h-5 w-5" aria-hidden="true" />
        </span>
        <Badge variant="secondary" className="bg-slate-100 text-[11px] text-slate-600">
          {service.badge}
        </Badge>
      </div>

      <h3 className="mt-4 text-lg font-semibold text-[#0b1d3a] sm:text-xl">{service.title}</h3>
      <p className="mt-2.5 text-sm leading-relaxed text-slate-600">{service.summary}</p>

      <ul className="mt-4 space-y-2">
        {service.points.map((point) => (
          <li key={point} className="flex items-start gap-2.5 text-sm text-slate-600">
            <Check className={`mt-0.5 h-4 w-4 shrink-0 ${accent.tick}`} aria-hidden="true" />
            <span>{point}</span>
          </li>
        ))}
      </ul>
    </Card>
  );
};
